import Cookies from 'js-cookie'

export default function() {
  const origin = window.location.origin.toString().split(':')
  Cookies.set(
    'tenantUrl',
    process.env.REACT_APP_TENANT_URL || `${origin[0]}:${origin[1]}`
  )
}
